enum CoreSpaceDatatypes {
    Motion = "Motion",
    Comfort = "Comfort",
    Toilet = "Toilet",
    Scale = "Scale",
    Unknown = "Unknown"
}

export default CoreSpaceDatatypes;